<p-dialog *ngIf="venueSelected" [(visible)]="venueSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw', height: '80vh' }">
	<ng-template pTemplate="header">
		<fa-icon [icon]="['far', 'store']" class="me-4" size="lg"></fa-icon>
		{{ venueSelected.name }}
	</ng-template>
	<app-dealer-venue-information [venueSelected]="venueSelected"></app-dealer-venue-information>
	<app-dealer-venue-tool-options [venueSelected]="venueSelected"></app-dealer-venue-tool-options>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]="true"
			(onCancelChange)="venueSelected = undefined; venueSelectedChange.emit(undefined)"
			(onSaveChange)="onSave()"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]=""
		></app-record-control-footer>
	</ng-template>
</p-dialog>
